import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { Steps } from 'primereact/steps';
import { InputText } from 'primereact/components/inputtext/InputText';
import { Tree } from 'primereact/tree';
import { MultiLanguage } from '../../utils/MultiLanguage';
import '../../styles/tablesSavedDialog.css';

const DialogType = Object.freeze({
  none: 0,
  delete: 1,
  rename: 2,
  copyItem: 3,
  switchLoc: 4, // switch location
  moveItem: 5,
  propertiesAr: 6, // Agorithm Rule
  propertiesHr: 7, // Hierachical Rule
  propertiesRr: 8, // Reference Rule
});

export default class TablesSavedDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      visibleSecond: false,
    };
    this.multiLanguage = new MultiLanguage();
  }

  moveInSteps(stepIn) {
    let { step } = this.state;
    step = step + stepIn;
    this.setState({ step });
  }

  toggleConfirm() {
    const { confirmDialog } = this.props;
    this.setState({ step: 0 });
    confirmDialog();
  }

  toggleHide() {
    const { onHide } = this.props;
    this.setState({ step: 0 });
    onHide();
  }

  renderFooter(currentDialogType, step) {
    const backDisabled = step === 0;
    let forwardDisalbed = false;
    if (currentDialogType === DialogType.propertiesAr && step === 2) forwardDisalbed = true;
    if (currentDialogType === DialogType.propertiesHr && step === 0) forwardDisalbed = true;
    if (currentDialogType === DialogType.propertiesRr && step === 1) forwardDisalbed = true;
    const back = (
      <Button
        disabled={backDisabled}
        className="p-button-primary"
        label="Zurück"
        icon="pi pi-chevron-left"
        onClick={() => this.moveInSteps(-1)}
      />
    );
    const forward = (
      <Button
        disabled={forwardDisalbed}
        className="p-button-primary"
        label="Weiter"
        icon="pi pi-chevron-right"
        onClick={() => this.moveInSteps(1)}
      />
    );
    const cont = (
      <Button
        id="continue"
        disabled={!this.isButtonEnabled()}
        label={this.getDialogConfirmButtonText()}
        icon="pi pi-check"
        onClick={() => this.toggleConfirm()}
      />
    );
    const cancel = (
      <Button
        id="cancel"
        label="Abbrechen"
        className="p-button-danger"
        icon="pi pi-times"
        onClick={() => this.toggleHide()}
      />
    );

    const ret = [];
    if (currentDialogType > 5) {
      ret.push(back);
      ret.push(forward);
    }
    ret.push(cont);
    if (currentDialogType < 6) ret.push(cancel);

    return (
      <div>
        {ret}
      </div>
    );
  }

  renderSecondFooter() {
    return (
      <div>
        <Button
          id="close"
          label="Schließen"
          icon="pi pi-check"
          onClick={() => this.setState({ visibleSecond: false })}
        />
      </div>
    );
  }

  getDialogText() {
    const { currentDialogType, currentNode, nodeName } = this.props;
    if (currentNode) {
      const { type } = currentNode;
      const typeText = {
        variable: 'das Merkmal',
        structure: 'die Tabelle',
        rule: 'die Regel',
      };
      switch (currentDialogType) {
        case DialogType.delete:
          let ret = 'Sind Sie sicher, dass Sie ' + typeText[type] + ' "' + nodeName + '" unwiderruflich löschen möchten?'
          if (type === 'variable') {
            ret = ret + ' Bitte bedenken Sie, dass das Löschen eines Merkmals Auswirkungen auf alle verknüpften Metadatenkomponenten hat.'
          }
          return <h3>{ret}</h3>;
        case DialogType.rename:
          return <h3>{`Bitte geben Sie einen neuen Namen für '${currentNode.data.name}' ein.`}</h3>;
        case DialogType.copyItem:
          return (
            <>
              <h3>
                Bitte geben Sie einen neuen Namen für die zu erstellende Kopie ein.
              </h3>
              <p>
                <b>Name der Tabelle:</b> {currentNode.data.name}
              </p>
            </>
          );
        case DialogType.moveItem:
          return <h3>xxx</h3>;
        case DialogType.propertiesAr:
          return undefined;
        case DialogType.propertiesHr:
          return undefined;
        case DialogType.propertiesRr:
          return undefined;
        default:
          return 'Ungültiger Typ';
      }
    }
  }

  makeTextInput(objectName) {
    const { newNodeDataName, setNewNodeDataName } = this.props;
    return (
      <span className="p-float-label" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <InputText
          style={{ width: '20rem' }}
          id="dialogInpText"
          value={newNodeDataName || ''}
          onChange={(e) => setNewNodeDataName(e.target.value)}
        />
        <label htmlFor="dialogInpText">{objectName}</label>
      </span>
    );
  }

  returnStepRr(step) {
    // if (step === 1) this.setState({ calculated: true });
    const { entry1, ruleStructure, returnType } = this.props;
    const { name, associationType } = entry1;
    const { langText } = this.props.entry1.shortDescription;
    const page = [];

    page[1] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <b>Übersicht über Regelstruktur und Regelmerkmale</b>
            </div>
            <div className="p-col-2 p-lg-12">
              <Tree value={ruleStructure} />
            </div>
          </div>
        </div>
      </div>
    );

    page[0] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <b>Referenzregel</b>
            </div>
            <div className="p-col-2 p-lg-2">
              <span />
              <span className="p-float-label">
                <InputText disabled id="name" defaultValue={name} />
                <label htmlFor="name">Name</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10" />
            <div className="p-col-2 p-lg-12">
              <span className="p-float-label">
                <InputText disabled id="kurztext" defaultValue={langText[0].text} />
                <label htmlFor="kurztext">Kurztext</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-12">
              <span className="p-float-label">
                <InputText disabled id="zuordnungsart" defaultValue={associationType} />
                <label htmlFor="zuordnungsart">Zuordnungsart</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-12">
              <b>Ergebnismerkmal</b>
            </div>
            <div className="p-col-2 p-lg-2">
              <span className="p-float-label">
                <InputText disabled id="ergebnisName" defaultValue={entry1.targetVariable} />
                <label htmlFor="ergebnisName">Name</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10">
              <span className="p-float-label">
                <InputText disabled id="ergebnisKurztext" defaultValue={entry1.targetVariableReference.shortDescription.langText[0].text} />
                <label htmlFor="ergebnisKurztext">Kurztext</label>
              </span>
            </div>

            <div className="p-col-2 p-lg-12">
              <b>Basismerkmal</b>
            </div>
            <div className="p-col-2 p-lg-12">
              <TabView
                activeIndex={this.state.activeIndex}
                onTabChange={(e) => this.setState({ activeIndex: e.index })}
              >
                <TabPanel header={entry1.baseVariableReferences[0].name}>
                  <br />
                  <div className="p-grid p-fluid">
                    <div className="p-col-2 p-lg-2">
                      <span className="p-float-label">
                        <InputText disabled id="name" defaultValue={entry1.baseVariableReferences[0].name} />
                        <label htmlFor="name">Name</label>
                      </span>
                    </div>
                    <div className="p-col-2 p-lg-7">
                      <span className="p-float-label">
                        <InputText disabled id="merkmaleText" defaultValue={entry1.baseVariableReferences[0].shortDescription.langText[0].text} />
                      </span>
                    </div>
                    <div className="p-col-2 p-lg-3">
                      <span className="p-float-label">
                        <InputText
                          disabled
                          id="typen"
                          defaultValue={returnType(entry1.baseVariableReferences[0].type)}
                        // defaultValue={entry1.baseVariableReferences[0].type}
                        />
                        <label htmlFor="typen">Typ</label>
                      </span>
                    </div>
                  </div>
                </TabPanel>
              </TabView>
            </div>
          </div>
        </div>
      </div>
    );

    return page[step];
  }

  returnStep(step) {
    const page = [];
    const { entry1, secondPage, currentDialogType } = this.props;
    const { name, statisticReference, measureUnitReference, decimals } = entry1;
    const { langText } = this.props.entry1.shortDescription;
    const merkmal = this.props.entry1.targetVariable;
    let { formula } = entry1.baseVariableReferences[0];
    if (!formula) formula = entry1.formula;
    const merkmalText = this.multiLanguage.returnInLanguage(this.props.entry1.targetVariableReference, 'de');
    page[0] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <b>Algorithmusregel</b>
            </div>
            <div className="p-col-2 p-lg-2">
              <span />
              <span className="p-float-label">
                <InputText disabled id="name" defaultValue={name} />
                <label htmlFor="name">Name</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10" />
            <div className="p-col-2 p-lg-12">
              <span className="p-float-label">
                <InputText disabled id="kurztext" defaultValue={langText[0].text} />
                <label htmlFor="kurztext">Kurztext</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-12">
              <b>Ergebnis der Berechnung</b>
            </div>
            <div className="p-col-2 p-lg-2">
              <span />
              <span className="p-float-label">
                <InputText disabled id="merkmal" defaultValue={merkmal} />
                <label htmlFor="merkmal">Merkmal</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10">
              <InputText disabled id="masseinheit" defaultValue={merkmalText} />
            </div>
            <div className="p-col-2 p-lg-2">
              <span />
              <span className="p-float-label">
                <InputText disabled id="statistik" defaultValue={statisticReference.name} />
                <label htmlFor="statistik">Statistik</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10">
              <InputText disabled id="statistikText" defaultValue={statisticReference.shortDescription.langText[0].text} />
            </div>
            <div className="p-col-2 p-lg-2">
              <span />
              <span className="p-float-label">
                <InputText disabled id="masseinheit" defaultValue={measureUnitReference.displayText.langText[0].text} />
                <label htmlFor="masseinheit">Maßeinheit</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10">
              <span />
              <span className="p-float-label">
                <InputText disabled id="decimals" defaultValue={decimals} />
                <label htmlFor="decimals">Nachkommastellen</label>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
    page[1] = (
      <div>
        <div className="card">
          <TabView
            activeIndex={this.state.activeIndex}
            onTabChange={(e) => this.setState({ activeIndex: e.index })}
          >
            {secondPage}
          </TabView>
        </div>
      </div>
    );
    page[2] = (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <span className="p-float-label">
                <InputText disabled id="formel" defaultValue={entry1.formula} />
                <label htmlFor="formel">Berechnungsformel</label>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
    return page[step];
  }

  makeRuleInputHr() {
    const kurztext = 'Kurztext';
    const data = [
      {
        key: '0',
        label: 'Verwendungszwecke des Individualkonsums, 2-Steller',
        data: 'Documents Folder',
        icon: 'pi pi-fw pi-inbox',
        children: [{
          key: '0-0',
          label: 'Verwendungszwecke des Individualkonsums, 3-Steller',
          data: 'Work Folder',
          icon: 'pi pi-fw pi-cog',
          children: [{ key: '0-0-0', label: 'Verwendungszwecke des Individualkonsums, 4-Steller', icon: 'pi pi-fw pi-file', data: 'Expenses Document' },]
        },
        ],
      },
    ];

    const { entry1, tabulated, ruleStructure, ruleStructureHr } = this.props;
    console.log('ENTRY#', entry1);
    const { name, hierarchyLevels } = entry1;
    const { langText } = this.props.entry1.shortDescription;

    return (
      <div>
        <div className="card">
          <div className="p-grid p-fluid">
            <div className="p-col-2 p-lg-12">
              <b>Hierarchieregel</b>
            </div>
            <div className="p-col-2 p-lg-2">
              <span />
              <span className="p-float-label">
                <InputText disabled id="name" defaultValue={name} />
                <label htmlFor="name">Name</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-10" />
            <div className="p-col-2 p-lg-12">
              <span className="p-float-label">
                <InputText disabled id="kurztext" defaultValue={langText[0].text} />
                <label htmlFor="kurztext">Kurztext</label>
              </span>
            </div>
            <div className="p-col-2 p-lg-12">
              <b>Hierarchieschritte</b>
            </div>
            <div className="p-col-2 p-lg-12">
              <TabView
                activeIndex={this.state.activeIndex}
                onTabChange={(e) => this.setState({ activeIndex: e.index })}
              >
                {tabulated}
              </TabView>
            </div>
            <div className="p-col-2 p-lg-12">
              <b>Übersicht über Regelstruktur und Regelmerkmale</b>
            </div>
            <Tree value={ruleStructureHr} />
          </div>
        </div>
      </div>
    );
  }

  makeRuleInputRr() {
    const interactiveItems = [
      {
        label: 'Regel/Merkmale',
      },
      {
        label: 'Regelstruktur',
      },
    ];
    const { step } = this.state;
    return (
      <div>
        <Steps
          id="wertmerkmal_bilden"
          model={interactiveItems}
          activeIndex={step}
          onSelect={(e) => this.setState({ step: e.index })}
          readOnly={false}
        />
        {this.returnStepRr(step)}
      </div>
    );
  }

  makeRuleInputAr() {
    const interactiveItems = [
      {
        label: 'Name/Ergebnis',
      },
      {
        label: 'Basisangaben',
      },
      {
        label: 'Formel',
      },
    ];
    const { step } = this.state;
    return (
      <div>
        <Steps
          id="wertmerkmal_bilden"
          model={interactiveItems}
          activeIndex={step}
          onSelect={(e) => this.setState({ step: e.index })}
          readOnly={false}
        />
        {this.returnStep(step)}
      </div>
    );
  }

  getDialogHeader() {
    const { currentDialogType, isVariable } = this.props;
    let returnValue;
    switch (currentDialogType) {
      case DialogType.delete:
        return 'Löschen';
      case DialogType.rename:
        return 'Umbenennen';
      case DialogType.copyItem:
        return 'Kopieren';
      case DialogType.moveItem:
        return 'Verschieben';
      case DialogType.propertiesAr:
        returnValue = (isVariable) ? 'Eigenschaften Merkmal' : 'Eigenschaften Algorithmusregel';
        return returnValue;
      case DialogType.propertiesHr:
        return 'Eigenschaften Hierarchieregel';
      case DialogType.propertiesRr:
        return 'Eigenschaften Referenzregel';
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogConfirmButtonText() {
    const { currentDialogType } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        return 'Löschen';
      case DialogType.rename:
        return 'Umbenennen';
      case DialogType.copyItem:
        return 'Kopieren';
      case DialogType.moveItem:
        return 'Verschieben';
      case DialogType.propertiesAr:
        return 'Schließen';
      case DialogType.propertiesHr:
        return 'Schließen';
      case DialogType.propertiesRr:
        return 'Schließen';
      default:
        return 'Ungültiger Typ';
    }
  }

  isButtonEnabled() {
    const { currentDialogType } = this.props;
    const { newNodeDataName } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        return true;
      case DialogType.rename:
        if (newNodeDataName && newNodeDataName.trim().length > 0) {
          return true;
        }
        return false;
      case DialogType.copyItem:
        if (newNodeDataName && newNodeDataName.trim().length > 0) {
          return true;
        }
        return false;
      case DialogType.moveItem:
        return undefined;
      default:
        return 'Ungültiger Typ';
    }
  }

  render() {
    const { onHide, currentDialogType, entry1 } = this.props;
    const { step, visibleSecond } = this.state;
    let style;
    if (currentDialogType < 6) {
      style = {
        overflowY: 'scroll',
        width: '800px',
        top: '10px',
        transform: 'unset',
        left: '400px',
      };
    } else {
      style = {
        overflowY: 'scroll',
        width: '800px',
        top: '10px',
        transform: 'unset',
        left: '400px',
        height: '620px',
      };
    }

    return (
      <div>
        <Dialog
          header={this.getDialogHeader(currentDialogType)}
          visible={currentDialogType}
          style={style}
          footer={this.renderFooter(currentDialogType, step)}
          onHide={() => this.toggleHide()}
          modal
        >
          <div>
            {this.getDialogText(currentDialogType)}
          </div>
          {(currentDialogType === DialogType.copyItem
            || currentDialogType === DialogType.rename)
            ? this.makeTextInput('Neuer Name') : undefined}
          {(currentDialogType === DialogType.propertiesAr)
            ? this.makeRuleInputAr() : undefined}
          {(currentDialogType === DialogType.propertiesHr)
            ? this.makeRuleInputHr() : undefined}
          {(currentDialogType === DialogType.propertiesRr)
            ? this.makeRuleInputRr() : undefined}
        </Dialog>
      </div>
    );
  }
}
